function getProductOfferingList(category) {
  let finalProducts = {};

  let items = Object.values(category?.rows) || [];

  for (let item of items) {
    const products = item?.items;
    if (products) {
      for (let product of products) {
        const po = product?.value?.productOffering;

        if (po) {
          let res = {
            title: {},
            price: {},
            additionalPrice: {},
            count: 0,
          };

          res.title = product?.value?.title;
          res.count = product?.value?.selected ? 1 : 0;

          res.price.price = product?.value?.price?.price;
          res.price.currency = product?.value?.price?.currency;

          if (product?.value?.additionalPrice) {
            res.additionalPrice.price = product?.value?.additionalPrice?.price;
            res.additionalPrice.prePriceText =
              product?.value?.additionalPrice?.prePriceText;
            res.additionalPrice.postPriceText =
              product?.value?.additionalPrice?.postPriceText;
          }

          finalProducts[po] = res;
        }
      }
    }
  }

  return finalProducts;
}

function getSelectCategories(configData) {
  let res = {};

  const categories = Object.keys(configData);

  for (let category of categories) {
    const categoryData = configData[category];
    const finalProducts = getProductOfferingList(categoryData);

    res[category] = {
      selectType: categoryData?.selectType || "unique",
      products: finalProducts,
      name: categoryData?.name,
      productFallback: categoryData?.productFallback,
      icon: categoryData?.icon,
    };
  }

  return res;
}

function main(data) {
  const selectCategories = getSelectCategories(data);

  return selectCategories;
}

export default main;
